import React, { useContext, useEffect } from "react";
import AdminLayout from "../../components/layout/AdminLayout";

import { Helmet } from "react-helmet";

import AdminInterestContext from "../../context/adminInterest/adminInterestContext";
import AdminemailLogsContext from "../../context/adminemailLogs/adminemailLogsContext";

import LoadingSpinner from "../../components/utilities/LoadingSpinner";
import EmailLogger from "../../components/emailAdmin/EmailLogger.js";


const EmailLoggerPage = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const adminInterestContext = useContext(AdminInterestContext);
  const adminemailLogsContext = useContext(AdminemailLogsContext);  
  // const { getEntrie, entrie, clearEntrie } = adminInterestContext;
  const { getEntrie, entrie, clearEntrie } = adminemailLogsContext;

  useEffect(() => {
    getEntrie(id);
    return () => {
      clearEntrie();
    };
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Email Log Details</title>
      </Helmet>
      <div id="email-logger-page">
        <div className="container">
          {Object.keys(entrie).length !== 0 ? (
            <EmailLogger formData={entrie} history={history} />
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default EmailLoggerPage;
